<template>
  <layout-main-inner title="培训记录">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <train-auto-select
          v-model="config.trainingVideoId"
          :callback="()=> { handleCurrentChange(1) }" />
        <el-input
          v-model="config.userName"
          clearable
          style="width: 200px;margin-left: 10px"
          placeholder="请输入培训人员"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="培训名称"
          min-width="180"
          prop="videoName"> </el-table-column>
        <el-table-column
          label="培训类型"
          width="90"
          prop="createdTime">
          <template slot-scope="{ row }">
            {{ row.trainingType | trainingTypeName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="姓名"
          min-width="180"
          prop="userName"> </el-table-column>
        <el-table-column
          label="手机号"
          min-width="130"
          prop="mobilePhone"> </el-table-column>
        <el-table-column
          label="单位名称"
          min-width="130"
          prop="vendorName"> </el-table-column>
        <!-- <el-table-column
          label="视频链接"
          min-width="240"
          prop="videoPlayUrl">
          <template slot-scope="{ row }">
            <el-link
              type="primary"
              style="font-size: 12px"
              :underline="false"
              :href="row.videoPlayUrl"
              target="_blank"
              rel="noopener noreferrer">{{ row.videoPlayUrl }}</el-link>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          label="视频分组"
          width="100"
          prop="status"></el-table-column> -->
        <el-table-column
          label="培训时间"
          width="120"
          prop="trainingTime">
          <template slot-scope="{ row }">
            {{ row.trainingTime | dateformat('YYYY-MM-DD') }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import TrainAutoSelect from '../../components/train-auto-select.vue'

export default {
  name: 'TrainingRecord',
  components: { TrainAutoSelect },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        userName: null,
        trainingVideoId: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/gettrainingrecords', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    generateinspectionreport() {
      this.loading = true
      this.$store.dispatch('account/generateinspectionreport', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
